module.exports = __webpack_public_path__ + "img/0-20.5327f0ee.gif";